module.exports = __webpack_public_path__ + "img/img_landing.9797ca07.svg";